import React, {useEffect, useState} from 'react';
import {ExpressCheckoutButtons} from '@wix/ecom-platform-express-checkout-buttons/widget';
import {ProvidedGlobalProps, withGlobalProps} from '../../../providers/globalPropsProvider';

export const CashierExpressButtonDataHook = 'cashier-express-button';

export const CashierExpressButton: React.FC<ProvidedGlobalProps> = withGlobalProps((props: ProvidedGlobalProps) => {
  const {currency, requestShipping, buttonStyle} = props.globals.cashierExpressCheckoutWidgetProps;
  const {isAllowedToCheckout, dynamicPaymentMethodsTheme, cashierExpressEstimatedTotal} = props.globals;

  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => setIsMounted(true), []);

  if (!isMounted) {
    return null;
  }

  return (
    <ExpressCheckoutButtons
      key={currency}
      dataHook={CashierExpressButtonDataHook}
      currency={currency}
      layout={'vertical'}
      theme={dynamicPaymentMethodsTheme}
      buttonStyle={buttonStyle}
      isShippable={requestShipping}
      estimatedTotal={cashierExpressEstimatedTotal}
      canStartPayment={isAllowedToCheckout}
    />
  );
});
